import React from 'react';
import { useData, useStatus, isNormal } from 'resift';
import EntityTypesContext from 'helpers/EntityTypesContext';
import _keyBy from 'lodash/keyBy';

import makeEntityTypesFetch from 'store/configuration/actions/entityTypesFetch';

interface Props {
  children: React.ReactNode;
}

function EntityTypesProvider({ children }: Props) {
  const entityTypesFetch = makeEntityTypesFetch();
  const entityTypesData = useData(entityTypesFetch);
  const status = useStatus(entityTypesFetch);

  const entityTypes = _keyBy(entityTypesData.results, 'typeKey');

  if (!isNormal(status)) {
    throw new Error(
      '[EntityTypesProvider] entity types fetch status was not normal. Ensure this provider is placed below the AppFetches component',
    );
  }

  if (!entityTypes) {
    throw new Error('[EntityTypesProvider] entity types was falsy');
  }

  return <EntityTypesContext.Provider value={entityTypes}>{children}</EntityTypesContext.Provider>;
}

export default EntityTypesProvider;
